import Sankey from './Sankey';

export default Sankey;
